import { useTranslation } from 'react-i18next';
import { FileText, Shield, Car, Fuel, MapPin, Clock, AlertTriangle, CreditCard, Scale } from 'lucide-react';

const TermsPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'fr';

  const termsFr = [
    {
      icon: <Shield className="w-5 h-5" />,
      title: "1. Champ d'application",
      content: "Les présentes conditions générales régissent toute location de véhicule effectuée auprès de Car Maintenance Meyrin Sàrl (ci-après « le Loueur »). Toute réservation implique l'acceptation pleine et entière des présentes conditions."
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "2. Conditions d'âge et de permis",
      content: [
        "Âge minimum : 18 ans révolus.",
        "Conducteurs entre 18 et 21 ans révolus : supplément de caution de CHF 500.–.",
        "Le locataire doit être titulaire d'un permis de conduire valide depuis au minimum 12 mois.",
        "Le Loueur se réserve le droit de refuser toute location sans justification."
      ]
    },
    {
      icon: <CreditCard className="w-5 h-5" />,
      title: "3. Caution",
      content: [
        "Caution standard : CHF 1'000.–",
        "Conducteurs 18–21 ans : CHF 1'500.–",
        "La caution est préautorisée ou débitée via Stripe.",
        "Le Loueur se réserve le droit de débiter tout montant dû (dommages, amendes, carburant, retard, nettoyage, kilométrage supplémentaire).",
        "La restitution de la caution intervient après contrôle du véhicule."
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "4. Kilométrage",
      content: "Chaque véhicule comprend 300 km par jour. Les kilomètres supplémentaires sont facturés selon le tarif défini lors de la réservation."
    },
    {
      icon: <Fuel className="w-5 h-5" />,
      title: "5. Carburant",
      content: "Politique : Plein / Plein. Le véhicule doit être restitué avec le même niveau de carburant. À défaut, le carburant manquant sera facturé : CHF 2.50 / litre HT, plus frais administratifs éventuels."
    },
    {
      icon: <MapPin className="w-5 h-5" />,
      title: "6. Zone d'utilisation",
      content: [
        "Les véhicules sont autorisés en Suisse et pays limitrophes (France, Allemagne, Italie, Autriche).",
        "Toute sortie non autorisée engage la responsabilité totale du locataire."
      ]
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      title: "7. Usage interdit",
      content: [
        "Il est strictement interdit d'utiliser le véhicule pour :",
        "• Transport rémunéré de personnes ou marchandises",
        "• Compétition ou conduite sportive",
        "• Sous-location",
        "• Conduite sous influence d'alcool ou stupéfiants",
        "• Conduite par une personne non déclarée",
        "En cas de violation, toutes assurances deviennent nulles et la responsabilité est totale."
      ]
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "8. Dommages et franchise",
      content: [
        "Le locataire est responsable de tous dommages constatés.",
        "Tarification :",
        "• Rayure < 5 cm par élément : CHF 300.– / rayure",
        "• Rayure jante : CHF 300.– / jante (non couverte par assurance)",
        "• Dommages supérieurs : facturation selon tarif carrosserie → CHF 180.– / heure, dans la limite de la franchise applicable."
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "9. Propreté du véhicule",
      content: "Le véhicule doit être restitué dans un état normal de propreté. En cas de salissure excessive : CHF 100.–"
    },
    {
      icon: <Clock className="w-5 h-5" />,
      title: "10. Retard de restitution",
      content: [
        "Tolérance : 1 heure",
        "Dès la 2ème heure : CHF 50.–",
        "Puis : CHF 50.– par heure supplémentaire",
        "Tout retard important peut entraîner la facturation d'une journée supplémentaire."
      ]
    },
    {
      icon: <FileText className="w-5 h-5" />,
      title: "11. Procès-verbal de livraison et restitution",
      content: "Un procès-verbal (PV) est établi à la livraison. En cas de restitution en dehors des heures d'ouverture ou en l'absence du client : le locataire accepte que le PV de restitution soit effectué unilatéralement par le Loueur. Les constatations feront foi."
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      title: "12. Infractions et amendes",
      content: "Le locataire est responsable de toute infraction. Des frais administratifs peuvent être facturés pour le traitement des amendes."
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "13. Accident ou vol",
      content: "Tout accident doit être déclaré immédiatement. Un constat européen d'accident doit être rempli. En cas de négligence ou faute grave, la responsabilité du locataire peut être illimitée."
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "14. Perte de clés / documents",
      content: "La perte des clés, papiers ou accessoires sera facturée au coût réel de remplacement."
    },
    {
      icon: <CreditCard className="w-5 h-5" />,
      title: "15. Facturation automatique",
      content: "Le locataire autorise expressément le Loueur à débiter : la caution, les frais supplémentaires, les dommages et les pénalités via le moyen de paiement enregistré."
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "16. Protection des données",
      content: "Les données personnelles sont traitées conformément au droit suisse. Les documents d'identité peuvent être conservés à des fins de sécurité et conformité."
    },
    {
      icon: <Clock className="w-5 h-5" />,
      title: "17. Politique d'annulation",
      content: [
        "Plus de 48h avant la prise en charge : annulation gratuite",
        "Moins de 48h avant la prise en charge : facturation d'1 jour minimum",
        "Moins de 24h avant la prise en charge : facturation jusqu'à 2 jours",
        "Retard supérieur à 2h sans prévenir : annulation automatique et facturation jusqu'à 2 jours"
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "18. Conditions spécifiques par véhicule",
      content: [
        "Certains véhicules peuvent être soumis à des conditions particulières :",
        "• Âge minimum supérieur à 18 ans",
        "• Ancienneté de permis supérieure à 12 mois",
        "• Caution supérieure à CHF 1'000.–",
        "Ces informations sont indiquées dans la description du véhicule concerné."
      ]
    },
    {
      icon: <Scale className="w-5 h-5" />,
      title: "19. Droit applicable et for juridique",
      content: "Le contrat est soumis au droit suisse. Le for exclusif est à Genève."
    }
  ];

  const termsEn = [
    {
      icon: <Shield className="w-5 h-5" />,
      title: "1. Scope of Application",
      content: "These general terms and conditions govern all vehicle rentals made with Car Maintenance Meyrin Sàrl (hereinafter \"the Lessor\"). Any reservation implies full acceptance of these conditions."
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "2. Age and License Requirements",
      content: [
        "Minimum age: 18 years old.",
        "Drivers aged 18 to 21: additional deposit of CHF 500.–.",
        "The renter must hold a valid driving license for at least 12 months.",
        "The Lessor reserves the right to refuse any rental without justification."
      ]
    },
    {
      icon: <CreditCard className="w-5 h-5" />,
      title: "3. Security Deposit",
      content: [
        "Standard deposit: CHF 1,000.–",
        "Drivers 18–21 years: CHF 1,500.–",
        "The deposit is pre-authorized or charged via Stripe.",
        "The Lessor reserves the right to charge any amount due (damages, fines, fuel, delays, cleaning, additional mileage).",
        "The deposit is refunded after vehicle inspection."
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "4. Mileage",
      content: "Each vehicle includes 300 km per day. Additional kilometers are charged according to the rate defined at booking."
    },
    {
      icon: <Fuel className="w-5 h-5" />,
      title: "5. Fuel",
      content: "Policy: Full / Full. The vehicle must be returned with the same fuel level. Otherwise, missing fuel will be charged: CHF 2.50 / liter (excl. VAT), plus any administrative fees."
    },
    {
      icon: <MapPin className="w-5 h-5" />,
      title: "6. Area of Use",
      content: [
        "Vehicles are authorized in Switzerland and neighboring countries (France, Germany, Italy, Austria).",
        "Any unauthorized travel engages the full liability of the renter."
      ]
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      title: "7. Prohibited Use",
      content: [
        "It is strictly forbidden to use the vehicle for:",
        "• Paid transport of persons or goods",
        "• Competition or sport driving",
        "• Subletting",
        "• Driving under the influence of alcohol or drugs",
        "• Driving by an undeclared person",
        "In case of violation, all insurance becomes void and liability is unlimited."
      ]
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "8. Damages and Excess",
      content: [
        "The renter is responsible for all damages observed.",
        "Pricing:",
        "• Scratch < 5 cm per panel: CHF 300.– / scratch",
        "• Rim scratch: CHF 300.– / rim (not covered by insurance)",
        "• Greater damages: charged according to bodywork rates → CHF 180.– / hour, up to the applicable excess limit."
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "9. Vehicle Cleanliness",
      content: "The vehicle must be returned in a normal state of cleanliness. In case of excessive dirt: CHF 100.–"
    },
    {
      icon: <Clock className="w-5 h-5" />,
      title: "10. Late Return",
      content: [
        "Tolerance: 1 hour",
        "From the 2nd hour: CHF 50.–",
        "Then: CHF 50.– per additional hour",
        "Significant delays may result in an additional day being charged."
      ]
    },
    {
      icon: <FileText className="w-5 h-5" />,
      title: "11. Delivery and Return Report",
      content: "A report (PV) is established upon delivery. In case of return outside business hours or in the absence of the customer: the renter accepts that the return report is made unilaterally by the Lessor. The findings will be binding."
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      title: "12. Violations and Fines",
      content: "The renter is responsible for all violations. Administrative fees may be charged for processing fines."
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "13. Accident or Theft",
      content: "Any accident must be reported immediately. A European accident report must be completed. In case of negligence or gross fault, the renter's liability may be unlimited."
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "14. Loss of Keys / Documents",
      content: "Loss of keys, papers or accessories will be charged at actual replacement cost."
    },
    {
      icon: <CreditCard className="w-5 h-5" />,
      title: "15. Automatic Billing",
      content: "The renter expressly authorizes the Lessor to charge: the deposit, additional fees, damages and penalties via the registered payment method."
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "16. Data Protection",
      content: "Personal data is processed in accordance with Swiss law. Identity documents may be retained for security and compliance purposes."
    },
    {
      icon: <Clock className="w-5 h-5" />,
      title: "17. Cancellation Policy",
      content: [
        "More than 48h before pickup: free cancellation",
        "Less than 48h before pickup: minimum 1 day charged",
        "Less than 24h before pickup: up to 2 days charged",
        "Delay of more than 2h without notice: automatic cancellation and up to 2 days charged"
      ]
    },
    {
      icon: <Car className="w-5 h-5" />,
      title: "18. Vehicle-Specific Conditions",
      content: [
        "Some vehicles may be subject to specific conditions:",
        "• Minimum age higher than 18 years",
        "• License held for more than 12 months",
        "• Security deposit higher than CHF 1,000.–",
        "This information is indicated in the vehicle description when applicable."
      ]
    },
    {
      icon: <Scale className="w-5 h-5" />,
      title: "19. Applicable Law and Jurisdiction",
      content: "The contract is governed by Swiss law. The exclusive jurisdiction is in Geneva."
    }
  ];

  const terms = lang === 'fr' ? termsFr : termsEn;

  return (
    <div className="min-h-screen bg-white pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <FileText className="w-10 h-10 text-[#4A945D]" />
            <h1 className="font-serif text-4xl text-[#181B1F]">
              {lang === 'fr' ? 'Conditions Générales de Location' : 'General Rental Terms'}
            </h1>
          </div>
          <div className="text-gray-500 space-y-1">
            <p className="font-medium">Car Maintenance Meyrin Sàrl</p>
            <p>Rue des Lattes 62, 1217 Meyrin – Suisse</p>
            <p>IDE: CHE-193.322.911</p>
          </div>
        </div>

        {/* Terms List */}
        <div className="space-y-6">
          {terms.map((term, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
              data-testid={`term-${index + 1}`}
            >
              <div className="flex items-start gap-4">
                <div className="p-2 bg-[#4A945D]/10 rounded-lg text-[#4A945D] shrink-0">
                  {term.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-medium text-[#181B1F] mb-3">{term.title}</h3>
                  {Array.isArray(term.content) ? (
                    <div className="space-y-2 text-gray-600">
                      {term.content.map((line, i) => (
                        <p key={i} className={line.startsWith('•') ? 'pl-4' : ''}>
                          {line}
                        </p>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-600">{term.content}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center text-gray-400 text-sm">
          <p>
            {lang === 'fr' 
              ? 'Dernière mise à jour : Mars 2026' 
              : 'Last updated: March 2026'}
          </p>
          <p className="mt-2">
            {lang === 'fr'
              ? 'En cas de litige, la version française fait foi.'
              : 'In case of dispute, the French version prevails.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
